export default __webpack_public_path__ + "static/media/mobile404.2a9f1d4c.svg";